import { useEffect, useState } from "react";
import CustomTable from "../../component/form/TableComponent";
import { Column } from "../../types/TableComponent.types";
import * as EventService from "../../api/event"
import { useAuth } from "../../context/authContext";
import { useNotification } from "../../context/notificationContext";
import { useNavigate } from "react-router-dom";
import { Button } from "../../component/form/Button";
import "./ViewEventScreen.css"

export const ViewEventScreen = () => {

    const queryString = window.location.search;
    const params = new URLSearchParams(queryString);
    const event_id: number = parseInt(params.get('event_id') + "");
    const { association } = useAuth();
    const { addNotification } = useNotification();
    const nav = useNavigate();

    const attendanceColums: Column[] = [
        {
            header: "Name surname",
            accessor: "sign"
        },
        {
            header: "Is attended",
            accessor: "attended"
        }
    ]


    const [eventInfo, setEventInfo] = useState<{
        id: number,
        name: string,
        start_date: Date | string,
        end_date: Date | string
    }>();

    const isEventDayOpen = () => {
        if (!eventInfo?.start_date || !eventInfo?.end_date) return false;
        const today = new Date().toISOString().split("T")[0];
        const start = new Date(eventInfo.start_date).toISOString().split("T")[0];
        const end = new Date(eventInfo.end_date).toISOString().split("T")[0];
        return today >= start && today <= end;
    };

    const loadEvent = async () => {
        if (Number.isNaN(event_id)) {
            addNotification("Numero evento invalido", "Il link che hai usato o il numero di evento non è valido", "error");
            nav("/events")
        }

        EventService.getById(association.id, event_id).then(data => {
            if (data.data.length == 0) {
                addNotification("Numero evento invalido", "Il link che hai usato o il numero di evento non è valido", "error");
                nav("/events")
            }

            setEventInfo(data.data[0]);

        })
    }

    useEffect(() => {
        loadEvent();
    }, [])


    return (
        <div className="event">
            <div className="event-info">
                <div className="event-info-header">
                    <h2>{eventInfo?.name}</h2>
                </div>
                <p>Data di inzio trasferta {eventInfo?.start_date + ""}</p>
                <p>Data di fine trasferta {eventInfo?.end_date + ""}</p>
            </div>
            <div className="event-attendance">
                <CustomTable columns={attendanceColums} buttons={[]} data={[{ sign: "Linus coupek", attended: "yes" }, { sign: "Linus coupek", attended: "yes" }, { sign: "Linus coupek", attended: "yes" }]} />
            </div>
            <Button name="I'm in" action={() => { }} textSize={24} />
            {isEventDayOpen() && (
                <Button name="Create report for today" action={() => nav(`/report/create?event_id=${event_id}`)} textSize={18} />
            )}

        </div>
    )
}
